import { useEffect, useState } from 'react';
import OrderMetricsDashboard from '../../components/OrderMetrics'; // adjust path if needed
import { IOrderListItem } from '../../types/orderMetrics';
import './styles.scss';
import { Divider } from '@mui/material';
import { OutletLabel } from '../../components/OutletLabel';

let counter = 1;

function generateOrderCode() {
  return `SO-${counter.toString().padStart(4, '0')}`;
}

function generateMockOrder(): IOrderListItem {
  const code = generateOrderCode();
  counter++;
  return { code };
}

export const DashboardPage = () => {
  const [pick, setPick] = useState<IOrderListItem[]>([]);
  const [pack, setPack] = useState<IOrderListItem[]>([]);

  useEffect(() => {
    // Initial data
    setPick(Array.from({ length: 6 }, generateMockOrder));
    setPack(Array.from({ length: 3 }, generateMockOrder));

    // Simulate workflow
    const interval = setInterval(() => {
      setPick((prev) => {
        if (prev.length > 0 && Math.random() > 0.4) {
          const [first, ...rest] = prev;

          setPack((p) => [...p, first]);
          return rest;
        }

        return [...prev, generateMockOrder()];
      });
    }, 3500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="dashboard-container">
      <div className="order-metrics-dashboard-container p-6">
        <OutletLabel label="Order Metrics" />
        <Divider
          component="li"
          sx={{ marginTop: '10px', marginBottom: '20px', listStyle: 'none' }}
        />
        This page is still in progress.
        {/* <OrderMetricsDashboard toPick={pick} toPack={pack} /> */}
      </div>
    </div>
  );
};
